import { useState, useEffect } from 'react';
// components
import Dialog from '../../components/dialog';
import { PasswordField, ButtonField, Label, CodeFields, Message as FormMessage } from '../../components/hook-form';
// @form
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @moment
import moment from 'moment-timezone';
// utils
import { REGEXP_EMAIL, REGEXP_PASSWORD } from '../../utils/regexp';
// styles
import { Tabs, Message, ButtonWrapper, PrimaryButton, TertiaryButton, Radio } from '../../styles';
// apis
import { receiveAlarm } from '../../apis';

// ----------------------------------------------------------------------

interface Props {
  receive: boolean;
  email: string;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
};

// ----------------------------------------------------------------------

export default function AlarmDialog({ receive, email, setVisible }: Props) {
  const handleClose = () => setVisible(false);

  const [ success, setSuccess ] = useState(null);

  const [ enabled, setEnabled ] = useState(receive);

  const [ message, setMessage ] = useState(email ? null : '계정 관리를 통해 이메일 등록을 먼저 진행해 주세요.');
  
  const onSubmit = async () => {
    await receiveAlarm(enabled)
      .then(() => setSuccess(true))
      .catch((error) => setMessage(error.message));
  };

  return (
    <Dialog
      title='알람 설정'
      handleClose={handleClose}
    >
      { !success ? (
        <>
          <div>
            <Label>이메일 알림 서비스 활성화</Label>
            <Radio>
              <label>
                <input type='radio' name='enabled' checked={enabled ? true : false} onChange={() => setEnabled(true)} disabled={email ? false : true} /> 사용
              </label>
              <label>
                <input type='radio' name='enabled' checked={!enabled ? true : false} onChange={() => setEnabled(false)} disabled={email ? false : true} /> 사용 안 함
              </label>
            </Radio>
          </div>
    
          <Message $visible={message ? true : false}>{ message }</Message>
    
          <ButtonWrapper>
            <PrimaryButton type='button' disabled={email ? false : true} onClick={() => onSubmit()}>
              설정
            </PrimaryButton>
            <TertiaryButton type='button' onClick={() => handleClose()} >
              취소
            </TertiaryButton>
          </ButtonWrapper>
        </>
      ) : (
        <>
          <p style={{'marginBottom': '30px'}}>이메일 알람 설정이 완료되었습니다.</p>

          <PrimaryButton type='button' onClick={() => handleClose()}>확인</PrimaryButton>
        </>
      )}
    </Dialog>
  );
}